export enum CAMPAIGN_STATUSES {
  Active = "active",
  Unactive = "unactive",
}

export enum OPPORTUNTY_TYPE {
  Event = "Event",
  Survey = "Survey",
}

export const CAMPAIGN_STATUS_LABELS: Record<CAMPAIGN_STATUSES, string> = {
  [CAMPAIGN_STATUSES.Active]: "Active",
  [CAMPAIGN_STATUSES.Unactive]: "Inactive",
};

export const OPPORTUNITY_TYPE_LABELS: Record<OPPORTUNTY_TYPE, string> = {
  [OPPORTUNTY_TYPE.Event]: "Event",
  [OPPORTUNTY_TYPE.Survey]: "Survey",
};

export const CAMPAIGN_STATUS_OPTIONS = Object.values(CAMPAIGN_STATUSES);
export const OPPORTUNITY_TYPE_OPTIONS = Object.values(OPPORTUNTY_TYPE);

export function normalizeCampaignStatus(value?: string | null): CAMPAIGN_STATUSES {
  switch (value) {
    case "active":
      return CAMPAIGN_STATUSES.Active;
    case "unactive":
      return CAMPAIGN_STATUSES.Unactive;
    default:
      return CAMPAIGN_STATUSES.Unactive;
  }
}

export function normalizeOpportunityType(value?: string | null): OPPORTUNTY_TYPE {
  switch (value) {
    case "survey":
    case "Survey":
      return OPPORTUNTY_TYPE.Survey;
    case "event":
    case "Event":
      return OPPORTUNTY_TYPE.Event;
    default:
      return OPPORTUNTY_TYPE.Event;
  }
}
